import { PageMeta } from '../insights/insights.models';

export const LEARNER_DASHBOARD_PAGE_META: Record<string, PageMeta> = {
	'^/learner-dashboard': {
		pagegroup: 'learner-pages',
		pagename: 'learner-dashboard'
	}
};
